import type { ColorLevel } from './types';

const TRUE_COLOR_PATTERN = /^(truecolor|24bits?)$/;

export const has256Color = (value: string | undefined): boolean => {
  return Boolean(value?.match(/256/));
};

export const supportsTrueColor = (value: string | undefined): boolean => {
  return Boolean(value?.match(TRUE_COLOR_PATTERN));
};

export const getColorSupport = (env: NodeJS.ProcessEnv) => {
  return {
    supports256Color: has256Color(env.TERM) || has256Color(env.COLORTERM),
    supportsTrueColor: supportsTrueColor(env.COLORTERM)
  };
};

const NO_BASIC_COLOR_TERMINALS = new Set([
  'dumb',
  'linux_console',
  'none',
  'unknown',
  'vt100'
]);

export const getColorLevel = (
  env: NodeJS.ProcessEnv,
  terminal?: string | null,
  colorSupport = getColorSupport(env)
): ColorLevel => {
  const { supports256Color, supportsTrueColor } = colorSupport;

  if (supportsTrueColor) {
    return 3;
  }

  if (supports256Color) {
    return 2;
  }

  if (terminal && !NO_BASIC_COLOR_TERMINALS.has(terminal)) {
    return 1;
  }

  if (env.TERM_PROGRAM || env.COLORTERM || env.TERMUX_VERSION) {
    return 1;
  }

  return 0;
};
